import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import LocalizedMessage from 'react-l10n';
import ReactLoading from 'react-loading';
import Field from '../fields/Field';
import FieldTextarea from '../fields/FieldTextarea';
import {
    axiosApprovalOrder,
    axiosRejectOrder,
    axiosContactCustomerOrder,
} from '../../actions/orderActions';
import { handleAxiosErrors } from '../../_utils';
import useManualReactTableState from '../ManualReactTableState';
import { getTranslation } from '../../lang/main';
import {
    createModal,
    hideModal,
} from '../../dom/components/confirm-removal-modal';
import { createAlert } from '../../dom/window';
import { validateForm } from '../../selectors/defaultSelectors';
import NoticeBox from '../common/NoticeBox';

const FORM_LABEL = {
    OperatorCode: getTranslation('FIELD.OPERATOR_CODE'),
    ResellerPurchaseOrder: getTranslation('FIELD.RESELLER_PURCHASE_ORDER'),
    By: getTranslation('FIELD.BY'),
    On: getTranslation('FIELD.ON'),

};

const constructMessage = (type = '', params) => {
    const { date, operatorCode, resellerPurchaseOrder } = params;
    const approvalType = type;

    let message = [];

    if (operatorCode) {
        message.push(`<strong>${approvalType} ${FORM_LABEL.By}:</strong> ${operatorCode}`);
    }
    if (resellerPurchaseOrder) {
        message.push(`<strong>${FORM_LABEL.ResellerPurchaseOrder}:</strong> ${resellerPurchaseOrder}`);
    }
    if (date) {
        message.push(`<strong>${approvalType} ${FORM_LABEL.On}:</strong> ${date}`);
    }
    return message.join(`<br />`);
};

function CheckoutConfirmation(props) {
    const { orderid, showActions = 1, approveDate, rejectDate, buyerContactedDate, initialOperatorCode, initialResellerPurchaseOrder, memberType, requestCallback = null, canProcessBackOrder, orderRejectedCallBack = null } = props;

    let fieldRefs = {};
    const [isValidated, setIsValidated] = useState(false);
    const [approvedDate, setApprovedDate] = useState(approveDate || '');
    const [rejectedDate, setRejectedDate] = useState(rejectDate || '');
    const [customerContactDate, setCustomerContactDate] = useState(buyerContactedDate || '');
    const [errors, setErrors] = useState([]);

    const identifier = orderid;
    const mrtState = useManualReactTableState({});
    let message = '';

    if (approveDate !== '' && typeof approveDate !== 'undefined') {
        message = constructMessage(getTranslation('APPROVED'), { date: approveDate, operatorCode: initialOperatorCode });
    }

    if (rejectDate !== '' && typeof rejectDate !== 'undefined') {
        message = constructMessage(getTranslation('REJECTED'), { date: rejectDate, operatorCode: initialOperatorCode });
    }

    if (buyerContactedDate !== '' && typeof buyerContactedDate !== 'undefined') {
        message = constructMessage(getTranslation('BUYER_CONTACTED'), { date: buyerContactedDate, operatorCode: initialOperatorCode });
    }

    const { isUserInputLoading, toggleUserInputLoading } = mrtState;
    const [showOrderButtons, setShowOrderButtons] = useState(showActions);
    const [orderPlacedMessage, setOrderPlacedMessage] = useState(message);
    const [operatorCode, setOperatorCode] = useState(initialOperatorCode || '');
    const [resellerPurchaseOrder, setResellerPurchaseOrder] = useState(initialResellerPurchaseOrder || '');

    // Request
    const handleFieldUpdate = (e) => {
        e.preventDefault();

        switch (e.target.name) {
            case 'OperatorCode':
                setOperatorCode(e.target.value);
                break;
            case 'ResellerPurchaseOrder':
                setResellerPurchaseOrder(e.target.value);
                break;
        }
    };

    const handleApprovalClick = (e, identifier, approvalStatus) => {
        const loadingKey = 'ApprovalStatus';

        const payload = {
            ID: identifier,
        };

        if (memberType == 'wholesaler' || memberType == 'global member') {
            payload.OperatorCode = operatorCode;
        }
        else if (memberType == 'reseller') {
            payload.ResellerPurchaseOrder = resellerPurchaseOrder;
        }
        else {
            return;
        }

        toggleUserInputLoading(identifier, loadingKey, true);

        const approvalOrder = () => {
            return axiosApprovalOrder(payload)
                .then((response) => {
                    const { data } = response;
                    const status = data.data.approveOrder.Status;
                    const orderPlacedDate = data.data.approveOrder.Approved;
                    const orderOperatorCode = data.data.approveOrder.OperatorCode || '';
                    const orderResellerPurchaseOrder = data.data.approveOrder.ResellerPurchaseOrder || '';
                    const errors = JSON.parse(data.data.approveOrder.NaitSequenceErrors) || [];

                    if (status) {
                        const message = constructMessage(getTranslation('APPROVED'), {
                            date: orderPlacedDate,
                            operatorCode: orderOperatorCode,
                            resellerPurchaseOrder: orderResellerPurchaseOrder
                        });
                        toggleUserInputLoading(identifier, loadingKey, false);
                        createAlert(
                            {
                                message,
                            },
                            'success'
                        );
                        window.location.reload();
                        // setShowOrderButtons(0);
                        // setOrderPlacedMessage(message);
                        // setApprovedDate(orderPlacedDate);
                        // setOperatorCode(orderOperatorCode);

                        // if (requestCallback) {
                        //     requestCallback();
                        // }
                    }

                    // Set errors
                    setErrors(errors);
                })
                .catch((error) => {
                    handleAxiosErrors(error);
                    toggleUserInputLoading(identifier, loadingKey, false);
                });
        };

        const rejectOrder = () => {
            return axiosRejectOrder(payload)
                .then((response) => {
                    const { data } = response;
                    const status = data.data.voidOrder.Status;
                    const orderPlacedDate = data.data.voidOrder.Voided;
                    const orderOperatorCode = data.data.voidOrder.OperatorCode || '';
                    const orderResellerPurchaseOrder = data.data.voidOrder.ResellerPurchaseOrder || '';

                    if (status) {
                        const message = constructMessage(getTranslation('REJECTED'), {
                            date: orderPlacedDate,
                            operatorCode: orderOperatorCode,
                            resellerPurchaseOrder: orderResellerPurchaseOrder
                        });
                        toggleUserInputLoading(identifier, loadingKey, false);
                        createAlert(
                            {
                                message,
                            },
                            'success'
                        );
                        setShowOrderButtons(0);
                        setOrderPlacedMessage(message);
                        setRejectedDate(orderPlacedDate);
                        setOperatorCode(orderOperatorCode);

                        if (orderRejectedCallBack) {
                            console.log("Before ---------------- > ");
                            orderRejectedCallBack();
                            console.log("After ---------------- > ");
                        }


                        if (requestCallback) {
                            requestCallback();
                        }
                    }

                    setErrors([]);
                })
                .catch((error) => {
                    handleAxiosErrors(error);
                    toggleUserInputLoading(identifier, loadingKey, false);
                });
        };

        const contactCustomerOrder = () => {
            return axiosContactCustomerOrder(payload)
                .then((response) => {
                    const { data } = response;
                    const status = data.data.buyerContactedOrder.Status;
                    const orderPlacedDate = data.data.buyerContactedOrder.BuyerContacted;
                    const orderOperatorCode = data.data.buyerContactedOrder.OperatorCode || '';
                    const orderResellerPurchaseOrder = data.data.buyerContactedOrder.ResellerPurchaseOrder || '';

                    if (status) {
                        const message = constructMessage(getTranslation('BUYER_CONTACTED'), {
                            date: orderPlacedDate,
                            operatorCode: orderOperatorCode,
                            resellerPurchaseOrder: orderResellerPurchaseOrder
                        });
                        toggleUserInputLoading(identifier, loadingKey, false);
                        createAlert(
                            {
                                message,
                            },
                            'success'
                        );
                        // setShowOrderButtons(0);
                        setOrderPlacedMessage(message);
                        setCustomerContactDate(orderPlacedDate);
                        setOperatorCode(orderOperatorCode);

                        if (requestCallback) {
                            requestCallback();
                        }
                    }

                    setErrors([]);
                })
                .catch((error) => {
                    handleAxiosErrors(error);
                    toggleUserInputLoading(identifier, loadingKey, false);
                });
        };

        // Declined
        if (approvalStatus === 'reject') {
            const modalName = 'confirm-reject-order-modal';
            const data = {
                heading: getTranslation(
                    'REJECT_CUSTOM_ORDER_MODAL.REJECT_ORDER_HEADING'
                ),
                noticeText: getTranslation(
                    'REJECT_CUSTOM_ORDER_MODAL.REJECT_ORDER_CONTENT'
                ),
                confirm: getTranslation(
                    'REJECT_CUSTOM_ORDER_MODAL.REJECT_ORDER_CONFIRM'
                ),
            };

            createModal(
                modalName,
                data,
                () => {
                    toggleUserInputLoading(identifier, loadingKey, true);
                    hideModal(modalName);
                    rejectOrder();
                },
                () => {
                    hideModal(modalName);
                }
            );

            toggleUserInputLoading(identifier, loadingKey, false);
        } else if (approvalStatus === 'contactCustomer') {
            // Contact Customer
            contactCustomerOrder();
        } else if (approvalStatus === 'approve') {
            // Approval
            approvalOrder();
        }
    };

    const renderLoading = () => {
        return (
            <div
                style={{
                    position: 'relative',
                    height: 35,
                    width: '100%',
                }}
            >
                <ReactLoading
                    type='spin'
                    className='button__spinner'
                    color='black'
                    height={20}
                    width={20}
                />
            </div>
        );
    };

    const renderOrderButtons = () => {
        return (
            <React.Fragment>
                <span
                    className='react-table__info'
                    onClick={(e) => e.stopPropagation()}
                >
                    {(memberType === 'wholesaler' || memberType == 'global member') && (
                        <FieldTextarea
                            required
                            ref={(r) => (fieldRefs.OperatorCode = r)}
                            label={FORM_LABEL['OperatorCode']}
                            animatedLabel={FORM_LABEL['OperatorCode']}
                            name='OperatorCode'
                            value={operatorCode || ''}
                            onChange={handleFieldUpdate}
                        />
                    )}
                    {memberType === 'reseller' && (
                        <Field
                            required
                            ref={(r) => (fieldRefs.ResellerPurchaseOrder = r)}
                            label={FORM_LABEL['ResellerPurchaseOrder']}
                            animatedLabel={FORM_LABEL['ResellerPurchaseOrder']}
                            name='ResellerPurchaseOrder'
                            value={resellerPurchaseOrder || ''}
                            onChange={handleFieldUpdate}
                        />
                    )}
                    {!canProcessBackOrder && (
                        <button
                            type='button'
                            disabled={!isValidated}
                            className={classnames('button button--less-fat button--green button--uppercase', !isValidated && 'button--disabled')}
                            onClick={(e) => handleApprovalClick(e, identifier, 'approve')}
                        >
                            <>
                                <span className='icon icon-check-thick' />
                                <span>
                                    <LocalizedMessage id={'APPROVE'} />
                                </span>
                            </>
                        </button>
                    )}
                    <button
                        type='button'
                        disabled={!isValidated}
                        className={classnames('button button--less-fat button--red button--uppercase', !isValidated && 'button--disabled')}
                        onClick={(e) => handleApprovalClick(e, identifier, 'reject')}
                    >
                        <>
                            <span className='icon icon-close-thick' />
                            <span>
                                <LocalizedMessage id={'REJECT'} />
                            </span>
                        </>
                    </button>
                    {(!canProcessBackOrder &&
                        <button
                            type='button'
                            disabled={!isValidated}
                            className={classnames('button button--less-fat button--orange button--uppercase', !isValidated && 'button--disabled')}
                            onClick={(e) => handleApprovalClick(e, identifier, 'contactCustomer')}
                        >
                            <>
                                <span className='icon icon-user-details' />
                                <span>
                                    <LocalizedMessage id={'CONTACT_CUSTOMER'} />
                                </span>
                            </>
                        </button>
                    )}
                </span>
            </React.Fragment>
        );
    };

    // - Validate form
    useEffect(() => {
        let status = !validateForm(fieldRefs);

        setIsValidated(status);
    }, [operatorCode, resellerPurchaseOrder]);

    return (
        <>
            {(errors && errors.length > 0) && (
                <NoticeBox
                    id="error-approval"
                    type={'error'}
                    icon={'icon-warning'}
                    content={
                        <React.Fragment>
                            <p>
                                There is something wrong when approving the orders.
                            </p>
                            <ul>
                                {errors.map((error, key) => {
                                    const { ItemID, ItemTitle, SequenceErrors = {} } = error;
                                    const sequenceErrors = Object.entries(SequenceErrors);

                                    return (
                                        <li key={key}>
                                            <strong>Item ID:</strong> {ItemID}<br />
                                            <strong>Item Title:</strong> {ItemTitle}<br />
                                            <strong>Sequence Errors:</strong><br />
                                            {sequenceErrors.length && (
                                                <ul>
                                                    {sequenceErrors.map(([number, errMessage], key) => {
                                                        return (
                                                            <li>
                                                                <strong>Sequence Number:</strong> {number} <br />
                                                                <strong>Error: </strong> {errMessage}
                                                            </li>
                                                        );
                                                    })}
                                                </ul>
                                            )}
                                        </li>
                                    )
                                })}
                            </ul>
                        </React.Fragment>
                    }
                />
            )}
            {isUserInputLoading(identifier, 'ApprovalStatus') ?
                renderLoading()
                :
                <React.Fragment>
                    {showOrderButtons === 1 && renderOrderButtons()}
                    <div className='text-box text-box--small'>
                        <p>
                            {(showOrderButtons === 0 && operatorCode !== undefined && operatorCode != '') && (
                                <React.Fragment>
                                    <strong><LocalizedMessage id={'FIELD.OPERATOR_CODE'} />:</strong> {operatorCode}<br />
                                </React.Fragment>
                            )}
                            {(showOrderButtons === 0 && resellerPurchaseOrder !== undefined && resellerPurchaseOrder != '') && (
                                <React.Fragment>
                                    <strong><LocalizedMessage id={'FIELD.RESELLER_PURCHASE_ORDER'} />:</strong> {resellerPurchaseOrder}<br />
                                </React.Fragment>
                            )}
                            {(approvedDate && approvedDate != '') && (
                                <React.Fragment>
                                    <strong><LocalizedMessage id={'FIELD.APPROVED_ON'} />:</strong> {approvedDate}<br />
                                </React.Fragment>
                            )}
                            {(rejectedDate && rejectedDate != '') && (
                                <React.Fragment>
                                    <strong><LocalizedMessage id={'FIELD.REJECTED_ON'} />:</strong> {rejectedDate}<br />
                                </React.Fragment>
                            )}
                            {(customerContactDate && customerContactDate != '') && (
                                <React.Fragment>
                                    <strong><LocalizedMessage id={'FIELD.CONTACT_CUSTOMER_ON'} />:</strong> {customerContactDate}<br />
                                </React.Fragment>
                            )}
                        </p>
                    </div>
                </React.Fragment>
            }
        </>
    );
}

export default CheckoutConfirmation;
